import { SOURCE_FILE_TYPES, TRANSITIONS, TEXTS, TEXT_POSITION } from 'enums'
import { AudioAsset, PlaceholderAsset, TransitionAsset } from 'models/Asset'
import ProjectVideoAsset from 'models/ProjectData/ProjectVideoAsset'
import { VideoAsset } from 'PropTypes'
import { getCoordsFromOffset } from '~/components/Preview/AssetsOverlay/lib'


export const isTransition = assetType => Object.values(TRANSITIONS).includes(assetType)

export const isText = assetType => Object.values(TEXTS).includes(assetType)

const imageExtensions = [ 'png', 'jpg', 'apng', 'avif', 'gif', 'jpeg', 'jfif', 'pjpeg', 'pjp', 'svg', 'webp' ]

export const isImage = asset => imageExtensions.includes(asset?.filetype)
|| asset?.sourceFileType === SOURCE_FILE_TYPES.IMAGES

const audioExtensions = [ 'mp3', 'm4a', 'flac', 'wav', 'wma', 'aac' ]

export const isAudio = assetType => audioExtensions.includes(assetType)

export const isResizableAsset = asset => !(asset instanceof TransitionAsset
  || asset instanceof PlaceholderAsset)

export const isVideo = asset => {
  let isVideo = true
  if (asset instanceof ProjectVideoAsset || asset instanceof VideoAsset) {
    return true
  }
  if (asset instanceof AudioAsset) {
    return false
  }
  for (const fn of [ isTransition, isText, isImage, isAudio ]) {
    isVideo = fn === isImage ? !fn(asset) : !fn(asset?.filetype ?? asset?.type)
    if (!isVideo) {
      break
    }
  }
  return isVideo
}

export const getVideoPosition = ({ offset, size,
  scale, boundingRect, rotation }) => {
  const scaledBounding = {
    width: boundingRect.width / scale.x,
    height: boundingRect.height / scale.y,
    x: boundingRect.offsetX / scale.x,
    y: boundingRect.offsetY / scale.y,
  }
  const { x, y, rotatedWidth, rotatedHeight } = getCoordsFromOffset(offset,
    { boundingRect: scaledBounding,
      assetKonvaSize: size,
      rotation,
      scale })

  return {
    x: Math.round(x - (rotatedWidth / 2)),
    y: Math.round(y - (rotatedHeight / 2)),
  }
}

export const compareAssetsSizes = (a, b) => a?.settings?.size?.width === b?.settings?.size?.width
  && a?.settings?.size?.height === b?.settings?.size?.height

export function isStretched(asset) {
  const { settings } = asset ?? {}
  if (!settings) {
    return false
  }
  return !!(settings.position === TEXT_POSITION.MIDDLE_CENTER
    && settings.relativeSize.width === 100
    && settings.relativeSize.height === 100)
}
